
import './styles.scss';

const Realize = {
  i18n: window.Realize.i18n,
};

export function NotFound() {
  return (
    <div className='not-found-container'>
      <i className='material-icons'>error_outline</i>
      <span>{Realize.i18n.t('exportMultipleModal.error.files_not_found')}</span>
    </div>
  )
}